module.exports = __webpack_public_path__ + "static/media/vit.5a759ce0.svg";